import { List, Record } from "immutable";

import ContentOptions from "./options/ContentOptions";

export type ContentId = string;
type SectionId = string;
type ModuleId = string;

export type ContentType = {
  id?: ContentId;
  parentId?: SectionId;
  tags: List<string>;
  prereqTags: List<string>;
  contentModuleIds: List<ModuleId>;
  options: ContentOptions;
};

export type OptionalContentType = Partial<ContentType>;

const defaultContent: ContentType = {
  id: undefined,
  parentId: undefined,
  tags: List(),
  prereqTags: List(),
  contentModuleIds: List(),
  options: new ContentOptions()
};

export default class Content extends Record(defaultContent) {}
